<template>
  <div class="calc-textarea-container">
    <div
      :id="textareaId"
      class="textarea"
      :style="{
        maxHeight: maxHeight + 'px',
        lineHeight: lineHeight
      }"
      @keyup="saveRangeSub('keyup')"
      @click="saveRangeSub('click')"
    ></div>
  </div>
</template>

<script>
import { replaceAll } from "@/utils/common"

export default {
  name: "calc-textarea",
  props: {
    textareaId: {
      type: String,
      default: "textarea"
    },
    canCalcFields: Array,
    maxHeight: {
      type: [String, Number],
      default: 34
    },
    lineHeight: {
      type: [String, Number],
      default: "30px"
    },
    control: Object
  },
  computed: {
    textareaElementId() {
      return "#" + this.textareaId
    }
  },
  watch: {
    "control.expression": {
      handler(newVal, oldVal) {
        if (newVal) this.initialData(newVal)
      },
      immediate: true
    }
  },
  methods: {
    initialData(expression) {
      if (!expression) expression = ""
      for (let item of this.canCalcFields) {
        expression = replaceAll(
          expression,
          item.regStr,
          `<div data-value="${encodeURIComponent(item.value)}">${item.label}</div> `
        )
      }
      this.$nextTick(() => {
        let textarea = document.querySelector(this.textareaElementId)
        textarea.innerHTML = expression
      })
    },
    // 保存光标位置
    saveRangeSub(from) {
      let selection = window.getSelection ? window.getSelection() : document.selection
      if (!selection.rangeCount) return
      let range = selection.createRange ? selection.createRange() : selection.getRangeAt(0)
      this.rangeStart = range
    },
    // 校验并输出表达式
    getOutputText() {
      let textarea = document.querySelector(this.textareaElementId)
      let outputStr = "",
        testStr = ""
      textarea.childNodes.forEach(node => {
        if (node.tagName == "DIV") {
          outputStr = outputStr + "" + decodeURIComponent(node.dataset.value.toString())
          testStr = testStr + "" + (Math.random() * 100).toFixed(5)
        } else if (node.textContent.trim() != "") {
          outputStr = outputStr + "" + node.textContent.trim()
          testStr = testStr + "" + node.textContent.trim()
        }
      })
      let { result, msg } = this.verifyOutputStr(testStr)
      if (!result) {
        return { result: result, msg: msg }
      }
      return { result: true, msg: outputStr }
    },
    // 校验表达式
    verifyOutputStr(testStr) {
      if (testStr == "") {
        return {
          result: false,
          msg: "请输入计算表达式"
        }
      } else {
        let reg = /([\u4E00-\u9FA5]|[\uFE30-\uFFA0])+/
        if (reg.test(testStr)) {
          return {
            result: false,
            msg: "计算表达式不允许输入中文符号"
          }
        } else {
          return { result: true, msg: "" }
        }
      }
    },
    // 插入变量
    insertItem(item) {
      let editDiv = document.querySelector(this.textareaElementId)
      if ("getSelection" in window) {
        let sel = window.getSelection()
        let div = document.createElement("div")
        div.innerHTML = item.label
        div.setAttribute("data-value", encodeURIComponent(item.value))
        if (!this.rangeStart) {
          this.rangeStart = document.createRange()
          this.rangeStart.selectNodeContents(editDiv)
          this.rangeStart.collapse(false)
          sel.removeAllRanges()
          sel.addRange(this.rangeStart)
        }
        this.rangeStart.insertNode(this.rangeStart.createContextualFragment("&nbsp;"))
        this.rangeStart.insertNode(div)
        this.rangeStart.collapse(false) // 对于IE来说，参数不可省略
        sel.removeAllRanges()
        sel.addRange(this.rangeStart)
        editDiv.focus()
      } else if ("selection" in document) {
        editDiv.focus()
        let range = document.selection.createRange()
        range.pasteHTML(
          "<div data-value='" + encodeURIComponent(item.value) + "'>" + item.label + "</div>"
        )
        editDiv.focus() // IE 11模拟的IE5~IE8无须这一步也能获得焦点
      }
    }
  }
}
</script>

<style lang="scss">
.calc-textarea-container {
  display: flex;
  position: relative;
  overflow: hidden;
  .textarea {
    width: 100%;
    padding: 4px 10px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    font-size: 14px;
    word-wrap: break-word;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-user-modify: read-write-plaintext-only;
    background-color: #fff;
    &:focus {
      border-color: #409eff;
      outline: none;
    }
    div {
      line-height: 24px;
      display: inline-flex;
      -webkit-user-modify: read-only;
      padding: 0 10px;
      margin: 1px 5px;
      background-color: #01ca83;
      color: #fff;
      border-radius: 14px;
      user-select: none;
      border: 1px solid #9cd7f1;
      &:focus {
        outline: none;
      }
    }
  }
}
</style>
